'use strict';

import './spinner.component.scss';
import spinnerTemplate from './spinner.component.html';

export default angular
  .module('maestro.directives.components.spinner', [])

  .directive('appSpinner', function() {
    return {
      replace: true,
      restrict: 'AEC',
      template: spinnerTemplate,
      scope: {
        size: '@'
      }
    };
  })
  .name;
